<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide13',
  data() {
    return {
      parallax: [
        {
          start: 10500,
          end: 11000,
          fromStyle: { opacity: 0 },
          toStyle: { opacity: 1 },
          easing: 'linear'
        },
        {
          start: 16000,
          end: 16400,
          fromStyle: { transform: 'translateY(-50%) translateX(-50%)' },
          toStyle: { transform: 'translateY(1600px) translateX(-50%)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/13_Couple.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 250px;
    height: 390px;
    left: calc(50% + 105px);
    top: calc(50% + 125px);
    transition: 0.6s;
    z-index: 6;
    transform: translateY(-50%) translateX(-50%);
    @media(max-width: 600px) {
      width: 130px;
      left: calc(50% + 16px);
      top: calc(50% + 55px);
    }
}
</style>
